import { Emoji, type EmojiItem, emojis } from '@tiptap-pro/extension-emoji';

import { emojiSuggestion } from './_components/emojiSuggestion';

const isRegionalIndicator = (emoji: EmojiItem) => emoji.name.startsWith('regional_indicator_');

// Suggestions should eventually be ranked by most-used emojis; until then,
// pushing the vendor's leading regional-indicator letters to the end is a
// quick way to keep the suggestion dropdown starting with faces.
const nativeEmojis: EmojiItem[] = emojis
  .map(({ fallbackImage, ...emoji }) => emoji)
  .sort((a, b) => Number(isRegionalIndicator(a)) - Number(isRegionalIndicator(b)));

export const createEmojiExtension = () =>
  Emoji.configure({
    emojis: nativeEmojis,
    enableEmoticons: true,
    suggestion: emojiSuggestion,
  });
